module.exports = __webpack_public_path__ + "img/pic_4.f5ce818d.jpg";